var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvangardLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 170,
    viewBox: "0 0 176 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4197 162.565H7.29454L6.147 165.905H0.820312L8.1338 146.705H13.5803L20.8938 165.905H15.5672L14.4197 162.565ZM13.1009 158.78L10.8571 152.391L8.61337 158.78H13.1009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1519 146.705H33.5852C35.3494 146.705 36.6853 147.133 37.6102 147.972C38.5351 148.828 38.9804 150.045 38.9804 151.638C38.9804 152.613 38.8091 153.401 38.4666 154.053C38.1241 154.686 37.5931 155.234 36.8737 155.662C37.5931 155.8 38.1925 156.004 38.6892 156.279C39.1859 156.553 39.597 156.896 39.9053 157.307C40.2136 157.717 40.4363 158.18 40.5733 158.676C40.7103 159.191 40.7788 159.739 40.7788 160.303C40.7788 161.211 40.6247 161.999 40.3163 162.702C40.008 163.404 39.5628 163.987 38.9975 164.466C38.4324 164.946 37.7302 165.305 36.9252 165.528C36.1202 165.75 35.1952 165.887 34.1676 165.887H26.1519V146.705ZM31.1531 154.241H32.078C33.6366 154.241 34.4245 153.624 34.4245 152.391C34.4245 151.157 33.6366 150.524 32.078 150.524H31.1531V154.241ZM31.1531 162.034H32.2493C33.4996 162.034 34.4073 161.879 34.9555 161.554C35.5035 161.229 35.7776 160.715 35.7776 159.995C35.7776 159.276 35.5035 158.763 34.9555 158.437C34.4073 158.112 33.5168 157.957 32.2493 157.957H31.1531V162.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3347 162.565H51.2095L50.062 165.905H44.7354L52.0317 146.705H57.4783L64.7918 165.905H59.4651L58.3347 162.565ZM56.9987 158.78L54.755 152.391L52.5112 158.78H56.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0515 154.121H82.2623V146.705H87.2636V165.905H82.2623V157.992H75.0515V165.905H70.0674V146.705H75.0515V154.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3369 165.905V146.705H105.316V150.935H99.3211V165.905H94.3369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.683 162.565H115.558L114.411 165.905H109.084L116.397 146.705H121.844L129.157 165.905H123.831L122.683 162.565ZM121.365 158.78L119.121 152.391L116.877 158.78H121.365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.417 165.905H134.433V146.705H142.38C144.538 146.705 146.182 147.27 147.33 148.383C148.477 149.496 149.043 151.09 149.043 153.127C149.043 155.165 148.477 156.741 147.33 157.872C146.182 159.002 144.52 159.55 142.38 159.55H139.417V165.905ZM139.417 155.525H141.078C142.911 155.525 143.836 154.721 143.836 153.127C143.836 151.534 142.911 150.73 141.078 150.73H139.417V155.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.466 161.674C156.117 161.674 156.527 161.486 156.733 161.109C156.938 160.732 157.024 160.167 157.024 159.448V146.705H172.765V161.674H175.179V169.485H170.212V165.887H158.669V169.485H153.702V161.674H155.466ZM167.763 150.935H162.009V159.499C162.009 159.995 161.991 160.407 161.974 160.749C161.94 161.091 161.889 161.4 161.803 161.691H167.763V150.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7565 47.2742H22.6152L36.4266 57.7615H60.1597L63.7565 47.2742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2918 74.9173L62.4229 77.5341L63.2918 74.9173Z",
    fill: "#3DF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.243 47.2742L115.83 57.7615H139.573L153.384 47.2742H112.243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.154 64.248L120.73 72.1187L130.814 64.248H118.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7549 64.248L55.1785 72.1187L45.0952 64.248H57.7549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.197 124.91L87.9951 0L46.8032 124.91L62.5142 113.745L87.9951 33.7759L113.052 113.442L129.197 124.91Z",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1675 84.7884L88.2169 81.6968L83.8523 85.0107L78.1943 102.763L88.2169 95.6496L97.8052 102.459L92.1675 84.7884Z",
    fill: "#DA291C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.359,
    height: 170,
    fill: "white",
    transform: "translate(0.820312)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvangardLogo);
export default __webpack_public_path__ + "static/media/avangard-logo.a9b2789f.svg";
export { ForwardRef as ReactComponent };